/**
 * 在线学习管理器
 * - 监听 hist store 更新
 * - 触发后台训练(不阻塞 UI)
 * - 训练完 setModel() 替换
 */
import { trainOnline } from './mlOnlineTrain.js';
import { setModel } from './mlPredict.js';

let training = false;
let lastTrainLen = 0;
let lastTrainAt = 0;

export async function maybeTrainOnline(history, force = false) {
  // 跳过条件:已经训过 / 数据没新 / 训练中
  if (training) return { skipped: true, reason: 'training' };
  if (!force && history.length === lastTrainLen) return { skipped: true, reason: 'no_new_data' };
  if (!force && Date.now() - lastTrainAt < 5 * 60 * 1000) return { skipped: true, reason: 'too_recent' };
  if (history.length < 100) return { skipped: true, reason: 'too_few_data' };

  training = true;
  try {
    console.log('[ML Online] 启动在线训练,数据:', history.length, '期');
    const t0 = Date.now();
    const newModel = trainOnline(history, {
      maxPeriods: 400,
      nTrees: 30,
      maxDepth: 4,
      onProgress: (p) => {
        if (p.stage === 'tree') console.log(`[ML Online] 树 ${p.t}/${p.total} (${p.elapsed}s)`);
        else if (p.stage === 'done') console.log(`[ML Online] 训练完成: ${p.nTrees} 棵,${p.elapsed}s`);
      },
    });
    setModel(newModel);
    const total = ((Date.now() - t0) / 1000).toFixed(1);
    console.log(`[ML Online] 模型已更新 (${total}s)`);
    lastTrainLen = history.length;
    lastTrainAt = Date.now();
    return { ok: true, nTrees: newModel.n_trees, totalSeconds: total };
  } catch (e) {
    console.error('[ML Online] 训练失败:', e);
    return { ok: false, error: e.message };
  } finally {
    training = false;
  }
}

export function getTrainingStatus() {
  return { training, lastTrainLen, lastTrainAt };
}
